<template>
    <div class="form-group row">
    <label :for="id" class="col-sm-2 col-form-label">
      <span v-html="this.tag" v-b-popover.hover.right="this.descr"></span>
    </label>
    <div class="col-sm-3">
        <input class="form-control" type="number" :min="vMin"
        :max="vMax"
        :step="step" v-model="_value" />
    </div>
    <div class="col-sm-2 col-form-label">{{this.vMin}}</div>
    <input
        type="range"
        class="col-sm-3 form-control-range"
        :id="id"
        :min="vMin"
        :max="vMax"
        :step="step"
        v-model="_value"
    />
    <div class="col-sm-2 col-form-label">{{this.vMax}}</div>
    </div>
</template>

<script>
export default {
  name: "FormRangeSlider",
  props: {
    id: String,
    descr: String,
    value: Number,
    vMin: Number,
    vMax: Number,
    step: Number,
    tag: String,
  },
  computed: {
    _value: {
        get () {return this.value},
        set (v) { this.$emit('update:value', Math.min(Math.max(this.vMin,v),this.vMax)); this.$emit("change")}
         
    }
  }
}

</script>